import { render, staticRenderFns } from "./ProposalCard.vue?vue&type=template&id=0f00c84e&scoped=true"
import script from "./ProposalCard.vue?vue&type=script&lang=js"
export * from "./ProposalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00c84e",
  null
  
)

export default component.exports